"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var INIT_FORM = exports.INIT_FORM = "INIT_FORM";
var FIELD_CHANGE = exports.FIELD_CHANGE = "FIELD_CHANGE";
var SUBMIT_FORM_PENDING = exports.SUBMIT_FORM_PENDING = "SUBMIT_FORM_PENDING";
var SUBMIT_FORM_COMPLETE = exports.SUBMIT_FORM_COMPLETE = "SUBMIT_FORM_COMPLETE";
var SUBMIT_FORM_ERROR = exports.SUBMIT_FORM_ERROR = "SUBMIT_FORM_ERROR";
var RESET_FORM = exports.RESET_FORM = "RESET_FORM";
var REMOVE_FORM = exports.REMOVE_FORM = "REMOVE_FORM";
var DISPLAY_FORM_ERRORS = exports.DISPLAY_FORM_ERRORS = "DISPLAY_FORM_ERRORS";
var VALIDATE_FIELD = exports.VALIDATE_FIELD = "VALIDATE_FIELD";
var VALIDATE_FORM = exports.VALIDATE_FORM = "VALIDATE_FORM";
var SET_REDIRECTION = exports.SET_REDIRECTION = "SET_REDIRECTION";
// file related actions
var FILE_UPLOAD_STARTED = exports.FILE_UPLOAD_STARTED = "FILE_UPLOAD_STARTED";
var FILE_UPLOAD_COMPLETED = exports.FILE_UPLOAD_COMPLETED = "FILE_UPLOAD_COMPLETED";
var FILE_UPLOAD_ERROR = exports.FILE_UPLOAD_ERROR = "FILE_UPLOAD_ERROR";
var FILE_REMOVE = exports.FILE_REMOVE = "FILE_REMOVE";
var SET_FIELD_PROPERTY = exports.SET_FIELD_PROPERTY = "SET_FIELD_PROPERTY";
var RESET_FILES = exports.RESET_FILES = "RESET_FILES";
var DELETE_FORM = exports.DELETE_FORM = "DELETE_FORM";
var UPDATE_FORM = exports.UPDATE_FORM = "UPDATE_FORM";
var CLEAR_FORMS = exports.CLEAR_FORMS = "CLEAR_FORMS";


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/redux/form/actionTypes.js
// module id = 117
// module chunks = 1143